import script from "./round.vue?vue&type=script&setup=true&lang=ts"
export * from "./round.vue?vue&type=script&setup=true&lang=ts"

import "./round.vue?vue&type=style&index=0&id=dadbefc4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dadbefc4"]])

export default __exports__